import React, { useMemo } from 'react';
import helpers from '@starflow/app/helpers';
import { useTempState } from '@starflow/app/store';

export const navContainerId = 'nav-container';

export const Navbar = () => {
  const centerContent = useTempState('navbarCenterContent');

  const [leftComponents, centerComponents, rightComponents] = useMemo(() => {
    const { left, center, right } = helpers.component.getNavBarComponents();

    const leftComponents = left.map(({ Component }, index) => <Component key={`${index}-left`} />);
    const centerComponents = center.map(({ Component }, index) => <Component key={`${index}-center`} />);
    const rightComponents = right.map(({ Component }, index) => <Component key={`${index}-right`} />);

    return [leftComponents, centerComponents, rightComponents];
  }, []);

  return (
    <nav
      className="flex items-center min-w-[1200px] justify-between flex-shrink-0 h-12 px-2 space-x-2 bg-[#2c2c2c] text-xs text-white relative"
      id={navContainerId}
    >
      <div className="flex items-center z-10">{leftComponents}</div>
      <div className="absolute w-full left-0">{centerContent || centerComponents}</div>
      <div className="z-10">{rightComponents}</div>
    </nav>
  );
};
